import React, { Component } from "react";
import { Table } from "antd";
import { TableLocale } from "@/utils/publicParam";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class LogDetail extends Component {
  constructor(props) {
    super(props);
    this.internationalization = this.props.intl.messages.logDetail;
    this.state = {
      data: [],
      pagination: {},
    };
    this.init();
  }

  init() {
    this.tableColumns = [
      {
        title: this.internationalization.title1, // '参数字段',
        dataIndex: "name",
        key: "name",
      },
      {
        title: this.internationalization.title2, // '变更前',
        dataIndex: "beforeUpdate",
        key: "beforeUpdate",
        className: "column-nowrap",
      },
      {
        title: this.internationalization.title3, // '变更后',
        dataIndex: "afterUpdate",
        key: "after",
      },
    ];
  }

  showDetailModal = () => {
    this.setState({
      visible: true,
    });
  };

  combineData(record) {
    let allParams = [];
    const cfgAfter = record.cfgAfterOperation || [];
    const cfgBefore = record.cfgBeforeOperation || [];
    const allItems = [];
    cfgAfter.map((item) => {
      item.children.map((childItem) => {
        allItems.push(childItem);
        return null;
      });
      return null;
    });

    cfgBefore.map((item) => {
      item.children.map((childItem) => {
        const arr = allItems.filter((item1) => item1.id === childItem.id);
        if (arr.length === 0) {
          allItems.push(childItem);
        }
        return null;
      });
      return null;
    });

    allItems.map((item) => {
      let isPlatformConfigHas = false;
      cfgAfter.map((item1) => {
        item1.children.forEach((childItem) => {
          if (childItem.id === item.id) {
            childItem.afterUpdate = childItem.value;
            allParams.push(childItem);
            isPlatformConfigHas = true;
          }
        });
        return null;
      });
      if (!isPlatformConfigHas) {
        item.afterUpdate = "";
        allParams.push(item);
      }
      return null;
    });
    allParams.map((item) => {
      cfgBefore.map((item1) => {
        item1.children.forEach((childItem) => {
          if (childItem.id === item.id) {
            item.beforeUpdate = childItem.value;
          }
        });
        return null;
      });
      return null;
    });

    allParams = allParams.filter(
      (item) => (item.afterUpdate && !item.beforeUpdate)
        || (!item.afterUpdate && item.beforeUpdate)
        || (item.afterUpdate
          && item.beforeUpdate
          && item.afterUpdate.toString() !== item.beforeUpdate.toString()),
    );
    this.setState({
      data: allParams,
    });
  }

  componentDidMount() {
    this.combineData(this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && this.props.data && nextProps.data.id !== this.props.data.id) {
      const pagination = this.state.pagination;
      pagination.current = 1;
      this.setState({
        pagination,
      });
      this.combineData(nextProps.data);
    }
  }

  handleTableChange = (pagination) => {
    this.setState({
      pagination,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const content = (
      <div className="sc-page-content">
        <div className="page-panel no-footer-table">
          <Table
            onChange={this.handleTableChange}
            bordered
            dataSource={this.state.data}
            loading={this.state.loading}
            columns={this.tableColumns}
            pagination={this.state.pagination}
            locale={TableLocale}
            footer={this.state.data && this.state.data.length ? () => <div></div> : null}
            className="sc-table"
          />
        </div>
      </div>
    );
    return content;
  }
}
export default injectIntl(LogDetail);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/logDetail.js